import { render } from "./B2bPageApprovalFlows.vue?vue&type=template&id=5756cf60&scoped=true&lang=pug"
import script from "./B2bPageApprovalFlows.vue?vue&type=script&lang=js"
export * from "./B2bPageApprovalFlows.vue?vue&type=script&lang=js"

import "./B2bPageApprovalFlows.vue?vue&type=style&index=0&id=5756cf60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5756cf60"]])

export default __exports__